<template lang="pug">
div
  div.neutral700--text.text-sm.font-semibold.mb-3 Are you sure you want to redeem this offer?
  redeem-offer-one-item(:offer="offer")
</template>

<script>
import RedeemOfferOneItem from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferOneItem.vue";

export default {
  components: {
    RedeemOfferOneItem,
  },
  props: {
    offer: {
      type: Object,
      default: () => ({})
    }
  },
}
</script>

<style scoped>
</style>